(function () {
  function applyFlavorColor(color) {
    if (color) {
      document.documentElement.style.setProperty('--iw-flavor-color', color);
      return;
    }

    document.documentElement.style.removeProperty('--iw-flavor-color');
  }

  function onFeaturedProductChange(event) {
    applyFlavorColor(event.detail?.flavorColor || null);
  }

  document.addEventListener('iw:featured-product-change', onFeaturedProductChange);

  const activeSwatch = document.querySelector('[data-iw-buy-box] .iw-featured-product__swatch.is-active');
  if (activeSwatch?.dataset.flavorColor) {
    applyFlavorColor(activeSwatch.dataset.flavorColor);
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHashId(hash) {
    if (!hash || hash === '#') return '';
    return decodeURIComponent(hash.slice(1));
  }

  function getTargetFromHash(hash) {
    const id = getHashId(hash);
    if (!id) return null;

    const element = document.getElementById(id);
    if (!element) return null;

    if (element.classList.contains('iw-featured-product__swatch')) {
      return document.getElementById('featured-product') || element;
    }

    return element;
  }

  function notifyHashNavigate(hash) {
    document.dispatchEvent(
      new CustomEvent('iw:hash-navigate', {
        detail: { hash },
      })
    );
  }

  function scrollToTarget(target, behavior) {
    const scrollBehavior = behavior || (prefersReducedMotion() ? 'auto' : 'smooth');
    const top = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: scrollBehavior,
    });
  }

  function scrollToHash(hash, behavior) {
    const target = getTargetFromHash(hash);
    if (!target) return false;
    notifyHashNavigate(hash);
    scrollToTarget(target, behavior);
    return true;
  }

  function shouldHandleLink(link) {
    const href = link.getAttribute('href');
    if (!href || href === '#') return false;

    if (href.startsWith('#')) {
      return Boolean(getTargetFromHash(href) || document.getElementById(getHashId(href)));
    }

    try {
      const url = new URL(href, window.location.href);
      if (url.pathname !== window.location.pathname || !url.hash) return false;
      return Boolean(getTargetFromHash(url.hash) || document.getElementById(getHashId(url.hash)));
    } catch {
      return false;
    }
  }

  function closeMobileMenuDrawer() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const mainDetailsToggle = headerDrawer.querySelector('#Details-menu-drawer-container');
    if (!mainDetailsToggle?.hasAttribute('open')) return;

    const summary = mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');

    if (typeof headerDrawer.closeMenuDrawer === 'function') {
      headerDrawer.closeMenuDrawer(new Event('click'), summary);
    }
  }

  function onAnchorClick(event) {
    const link = event.currentTarget;
    if (!shouldHandleLink(link)) return;

    let hash = link.getAttribute('href');
    if (!hash.startsWith('#')) {
      hash = new URL(link.href, window.location.href).hash;
    }

    event.preventDefault();
    if (scrollToHash(hash)) {
      history.pushState(null, '', hash);
      link.blur();
    }
  }

  function bindMenuDrawerNavLinks(root = document) {
    root.querySelectorAll('header-drawer .menu-drawer__navigation a[href]').forEach((link) => {
      if (link.dataset.iwMenuNavBound === 'true') return;

      link.dataset.iwMenuNavBound = 'true';
      link.addEventListener('click', closeMobileMenuDrawer);
    });
  }

  function bindAnchorLinks(root = document) {
    root.querySelectorAll('a[href*="#"]').forEach((link) => {
      if (link.dataset.iwScrollBound === 'true') return;
      if (!shouldHandleLink(link)) return;

      link.dataset.iwScrollBound = 'true';
      link.addEventListener('click', onAnchorClick);
    });
  }

  function handleInitialHash() {
    if (!window.location.hash) return;

    requestAnimationFrame(() => {
      scrollToHash(window.location.hash, prefersReducedMotion() ? 'auto' : 'auto');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindAnchorLinks();
      bindMenuDrawerNavLinks();
      handleInitialHash();
    });
  } else {
    bindAnchorLinks();
    bindMenuDrawerNavLinks();
    handleInitialHash();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindAnchorLinks(event.target);
    bindMenuDrawerNavLinks(event.target);
  });
})();
